
import { PageRequest } from "@/store/shared/entity";
import {
  Component,
  Mixins,
  ActionButtonConfig,
  PageResultBaseMixins,
  PageResultModalMixins,
  appConst,
  PageResultListMixins,
} from "@/lib";
import CreateExportprofit from "./component/create-exportprofit.vue";
import EditExportprofit from "./component/edit-exportprofit.vue";

class PageDeclareCustomsRequest extends PageRequest {
  shipmentDate = [
    new Date(new Date().setMonth(new Date().getMonth() - 3))
      .toISOString()
      .slice(0, 10),
    new Date().toISOString().slice(0, 10),
  ];
}

@Component({
  name: "exportprofit.list",
  components: {CreateExportprofit,EditExportprofit  },
})
export default class DeclareCustomsView extends Mixins(
  PageResultBaseMixins,
  PageResultModalMixins,
  PageResultListMixins
) {
  sectionButtons = { ...this.addBtn() };

  data: any = {
    model: new PageDeclareCustomsRequest(),
    queryAction: "reportstatistics/exportprofit/getAll",
    isAutoQuery: false,
    cols: this.resultColumns,
  };
  async activated() {
    await this.$store.dispatch("system/customer/getCustomerList");
  }

  reset() {
    this.data.model = new PageDeclareCustomsRequest();
  }
 createRealExchangeRate(){

     this.open("create-modal");
        }
          get businessGroupList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.businessGroup)
  }
   //客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }
  get resultColumns() {
    return [
      this.$util.render.codeColumn(
        "app.DeclareCustoms.BusinessGroup",
        "businessGroup",
        () => this.getCodeListByCategory(appConst.codeCategory.businessGroup),
        { minWidth: 100 }
      ),

      {
        title: this.L("app.DeclareCustoms.CustomerName"),
        key: "customerName",
        minWidth: 250,
      },

      {
        title: this.L("app.FactoryCost.FactoryName"),
        key: "name",
        tooltip: true,
        minWidth: 300,
        render: (h, { row }) => {
          let list = row.factoryName;
          let result = [];
          if (list) {
            list.forEach((item, index) => {
              result.push(h("span", {}, item));
              result.push(h("br"));
            });
          }

          return h("div", {}, result);
        },
      },

      {
        title: this.L("app.DeclareCustoms.ShippingNumber"),
        key: "shippingNumber",
         minWidth: 150,
      },

      // this.$util.render.dateColumn(
      //   "app.DeclareCustoms.ShipmentDate",
      //   "shipmentDate",

      //   { width: 120 }
      // ),
 {
        title: this.L("app.DeclareCustoms.ShipmentDate"),
        key: "shipmentDateStr",
         minWidth: 150,
      },
      {
        title: this.L("app.DeclareCustoms.ForeignExchange"),
        key: "receiverAmount",
          minWidth: 200,
        render: (h: any, params: any) => {
              if(!!params.row.receiverAmount){
          return [h("span", this.$util.format.amount(params.row.receiverAmount))];
          }
          else{return [h("span", "N/A")];}
        },
      },

      {
        title: this.L("app.Factory.Amount"),
        key: "factoryAmount",
         minWidth: 200,
        render: (h: any, params: any) => {
          return [
            h("span", this.$util.format.amount(params.row.factoryAmount)),
          ];
        },
      },

      {
        title: this.L("app.ExportProfit.Freight"),
        key: "freight",
         minWidth: 200,
        render: (h: any, params: any) => {
          if(!!params.row.freight||params.row.freight==0){
          return [h("span", this.$util.format.amount(params.row.freight))];
          }
          else{return [h("span", "N/A")];}
        },
      },
         {
        title: this.L("app.ExportProfit.Drawback"),
        key: "drawback",
         minWidth: 200,
        render: (h: any, params: any) => {
          return [
            h("span", this.$util.format.amount(params.row.drawback)),
          ];
        },
      },
   {
        title: this.L("app.LogisticsCost.ExchangeRate"),
        key: "exchangeRate",
           minWidth: 80,
        render: (h: any, params: any) => {
         if(!!params.row.exchangeRate){
          return [h("span", this.$util.format.amount(params.row.exchangeRate))];
           }
          else{return [h("span", "N/A")];}
        },
      },
       {
        title: this.L("app.ExportProfit.AmountReceivedUSD"),
        key: "amountReceivedUSD",
         minWidth: 200,
        render: (h: any, params: any) => {
               if(!!params.row.amountReceivedUSD){
          return [h("span", this.$util.format.amount(params.row.amountReceivedUSD))];
            }
          else{return [h("span", "N/A")];}
        },
      },
         {
        title: this.L("app.ExportProfit.AmountReceivedRMB"),
        key: "amountReceivedRMB",
         minWidth: 200,
        render: (h: any, params: any) => {
             if(!!params.row.amountReceivedRMB){
          return [h("span", this.$util.format.amount(params.row.amountReceivedRMB))];
             }
          else{return [h("span", "N/A")];}
        },
      },
           {
        title: this.L("app.DeclareCustoms.BankFee"),
        key: "bankCharges",
         minWidth: 200,
        render: (h: any, params: any) => {
          return [
            h("span", this.$util.format.amount(params.row.bankCharges)),
          ];
        },
      },
            {
   
      },
         this.$util.render.codeColumn(
        "app.ExportProfit.ProfitType",
        "profitType",
        () =>
          this.getCodeListByCategory(
            appConst.codeCategory.profitType
          ),
        {width: 150}
      ),
              {
        title: this.L("app.ExportProfit.Profit"),
        key: "profit",
            minWidth: 200,
        render: (h: any, params: any) => {
               if(!!params.row.profit){
          return [h("span", this.$util.format.amount(params.row.profit))];
           }
          else{return [h("span", "N/A")];}
        },
      },
               {
        title: this.L("app.ExportProfit.ProfitMargin"),
        key: "profitMargin",
            minWidth: 100,
               render: (h: any, params: any) => {
               if(!!params.row.profitMargin){
          return [h("span", params.row.profitMargin)];
           }
          else{return [h("span", "N/A")];}
        },
   
      },
                  {
        title: this.L("app.ExportProfit.Remark"),
        key: "profitRemark",
            minWidth: 150,

      },
      this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})
    ];
  }

  get colButtons(): ActionButtonConfig[] {
    return [
      {
        label: "app.ExportProfit.InputRemark",
        permission: "RIMS.ExportProfit",
        callback: async (row: any) => {
           this.$store.commit("reportstatistics/exportprofit/edit", row );
         this.open("edit-modal");
        },
      },

      ,
    ];
  }
}
